import { createSelector } from 'reselect';
import { createPrimarySelector } from '../../../utils/helpers';
import { selectBands } from '../bands/selectors';
import _ from '../../../utils/lodash';
import {
  selectTreatmentInstanceSortingIteratee,
  selectTreatmentInstanceSorting,
} from '../../areas/dailyPlanning/index';

export const selectTreatmentInstances = createPrimarySelector(state => state.entities.treatmentInstances.general.items);

export const selectTreatmentInstancesWithBands = createSelector(
  selectTreatmentInstances,
  selectBands,
  (treatmentInstances, bands) =>
    treatmentInstances.map(treatmentInstance => ({
      ...treatmentInstance,
      highestGrade: bands[treatmentInstance.highestGradeEquivalence],
    })),
);

export const selectSortedTreatmentInstancesWithBands = createSelector(
  selectTreatmentInstancesWithBands,
  selectTreatmentInstanceSorting,
  selectTreatmentInstanceSortingIteratee,
  (treatmentInstances, sorting, sortingIteratee) => {
    const instances = treatmentInstances.slice();
    const masters = _.remove(instances, i => !i.masterId);
    // orphans = copies without master on the list
    const orphans = instances.filter(i => masters.every(m => m.treatmentInstanceId !== i.masterId));
    if (orphans.length > 0) {
      _.remove(instances, i => masters.every(m => m.treatmentInstanceId !== i.masterId));
    }
    const mastersWithOrphans = masters.concat(orphans);
    // copies - copies with master on the list / what's left after the removes
    const copies = instances;
    const orderedMastersWithOrphans = _.orderBy(mastersWithOrphans, sortingIteratee, [
      sorting.orderDir,
      'asc',
      'asc',
      'desc',
      'asc',
    ]);
    const orderedCopies = _.orderBy(copies, sortingIteratee, [sorting.orderDir, 'asc', 'asc', 'desc', 'asc']);
    const results = orderedMastersWithOrphans.reduce(
      (orderedItems, master) =>
        orderedItems.concat(
          master,
          orderedCopies.filter(i => i.masterId === master.treatmentInstanceId && i.treatmentId === master.treatmentId),
        ),
      [],
    );
    return results;
  },
);
